import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
interface ParallaxProps {
  image: string;
  height?: string;
  overlayColor?: string;
  children?: React.ReactNode;
  className?: string;
}
export function Parallax({
  image,
  height = '400px',
  overlayColor = 'bg-brand-teal/60',
  children,
  className = ''
}: ParallaxProps) {
  const ref = useRef<HTMLDivElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  // Move the background image slightly slower than the scroll speed
  const y = useTransform(scrollYProgress, [0, 1], ['-20%', '20%']);
  return <div ref={ref} style={{
    height
  }} className={`relative overflow-hidden w-full flex items-center justify-center ${className}`} data-id="element-179">
      <motion.div style={{
      y,
      backgroundImage: `url(${image})`
    }} className="absolute inset-[-20%] bg-cover bg-center z-0" data-id="element-180" />
      <div className={`absolute inset-0 z-10 ${overlayColor}`} data-id="element-181" />

      {children && <div className="relative z-20 w-full" data-id="element-182">{children}</div>}
    </div>;
}